import * as React from "react";
import * as ReactDOM from "react-dom";
import { EventManager } from "../popup/globals";
import { OptionalLink } from "../optionalLink";

interface IProperties
{
    /**
     * Ein gebundenes Objekt.
     */
    dataSource?: any,

    /**
     * Anzeige Text.
     */
    header: string,

    /**
     * Name des Icons welches angezeigt werden soll.
     */
    icon?: string,

    /**
     * Die Farbe des Icons.
     */
    iconColor?: string,

    /**
     * Link (react-router).
     */
    linkTo?: string | {},

    /**
     * Link.
     */
    externalLink?: string,

    /**
     * Angabe, ob das Item größer gerendert werden soll.
     */
    isBig?: boolean,

    /**
     * Angabe, ob das Item abgeschaltet ist.
     */
    isDisabled?: boolean,

    /**
     * Angabe, ob das Item sichtbar ist.
     */
    isVisible?: boolean,

    /**
     * Angabe, ob das Item einen Einzug hat.
     */
    noIndent?: boolean,

    /**
     * Wird ausgeführt, sobald auf das Item geklickt wird.
     */
    onClick?: (dataSource?: any) => void
}

export class MenuItem extends React.Component<IProperties>
{
    /**
     * Standardwerte setzen.
     */
    public static defaultProps: Partial<IProperties> = {
        icon: null,
        isBig: false,
        isDisabled: false,
        isVisible: true,
        noIndent: false
    };

    /**
     * Führt die "onClick" Eigenschaft aus wenn diese gesetzt wurde.
     * @param e Das auslösende Ereignis.
     */
    private onClick = (e: React.MouseEvent<HTMLElement>) =>
    {
        const { dataSource, onClick } = this.props;

        if (EventManager.has("hide"))
            EventManager.emit("hide", e.nativeEvent);

        if (onClick != null)
            onClick(dataSource);
    }

    /**
     * Rendert diese Komponente.
     */
    public render(): JSX.Element
    {
        const { dataSource, header, icon, iconColor, linkTo, externalLink, isBig, isDisabled, isVisible, noIndent, onClick } = this.props;

        if (!isVisible)
            return null;

        var attributes = {};
        if (isDisabled)
            attributes["disabled"] = "disabled";

        if (externalLink != null)
        {
            attributes["href"] = externalLink;
            attributes["target"] = "_blank";
        }

        return (
            <OptionalLink
                className={`contextmenu_item ${(noIndent) ? "contextmenu_item--no-indent" : ""} ${(isBig) ? "contextmenu_item--big" : ""}`}
                onClick={this.onClick}
                onContextMenu={(e) => e.preventDefault()}
                to={linkTo}
                {...attributes}>
                {(icon != null) ? <i className={`contextmenu_item_icon mdi mdi-${icon}`} style={{ color: iconColor }}></i> : null}
                <span className="contextmenu_item_text">{header}</span>
            </OptionalLink>
        );
    }
}